import React, { useEffect, useState, useCallback } from "react";

import {
  CircularProgress,
  Box,
  Container,
  Pagination,
  PaginationItem,
} from "@mui/material";

import NoCard from "../../components/userProfile/paymentMethod/noCard";
import {
  checkUserBank,
  getBalance,
  getTransaction,
} from "../../setup/api/services/payment";
import { AuthConfig } from "../../setup/context/config/authConfig";

import { wallets } from "./constants";

import "./styles.css";
import TransactionsList from "./TransactionsList";
import { EmptyContractsList } from "../contract/list/emptyContractList";

const Wallets = () => {
  const [bankInfoEmpty, setBankInfoEmpty] = useState<boolean>(false);
  const [page, setPage] = React.useState(1);
  const [pagesCount, setPagesCount] = React.useState(1);
  const [balanceInfo, setBalanceInfo] = React.useState(0);

  const pageSize = 10;
  const [loading, setLoading] = useState<boolean>(false);
  const [transactionsInfo, setTransactionsInfo] = React.useState([]);

  const userId = AuthConfig?.getUserInfo()?.id;

  const fetchBankInfo = useCallback(async () => {
    try {
      setLoading(true);
      const respons = await checkUserBank(userId);
      return respons;
    } catch (error) {
      console.error;
    }
    setLoading(false);
  }, []);

  const fetchTransactionsInfo = useCallback(async (page) => {
    setLoading(true);
    try {
      const response = await getTransaction(page - 1, pageSize);
      setTransactionsInfo(response.data.content);
      setPagesCount(response.data.totalPages);
    } catch (error) {
      console.error;
    }
    setLoading(false);
  }, []);

  const fetchBalanceInfo = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getBalance(userId);
      setBalanceInfo(response.data.balance);
    } catch (error) {
      console.error;
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchBankInfo()
      .then((res) => {
        if (res != undefined) {
          setBankInfoEmpty(false);
          fetchTransactionsInfo(page).then().catch(console.error);
          fetchBalanceInfo().catch(console.error);
        } else {
          setBankInfoEmpty(true);
        }
      })
      .catch(console.error);
  }, []);

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
    fetchTransactionsInfo(value).then().catch();
  };

  if (loading)
    return (
      <Box className="container center">
        <CircularProgress />
      </Box>
    );

  return (
    <Container>
      <div className="wallets-title">{wallets.WALLETS_HEADING}</div>

      {bankInfoEmpty ? (
        <div className="wallets-container-empty">
          <NoCard
            handleClick={() => {
              console.log("NO_CARD_ACTION");
            }}
          />
        </div>
      ) : (
        <>
          {transactionsInfo.length !== 0 ? (
            <>
              <div className="wallets-balance-card">
                <div className="wallets-balance-card__title">
                  <span>{wallets.BALANCE}</span>
                  <span>
                    <Box component="img" src="/assets/images/svg/euro.svg" />
                  </span>
                </div>
                <div className="wallets-balance-card__number">
                  {balanceInfo.toLocaleString()}
                  <span>{wallets.SAR}</span>
                </div>
              </div>
              <div className="wallet-container">
                {wallets.ALL_TRANS}
                <span className="wallet-container__number">
                  {transactionsInfo.length}
                </span>
              </div>
              {transactionsInfo.map((transactionsInfoItem: any) => {
                return (
                  <TransactionsList
                    key={transactionsInfoItem.id}
                    transactionsInfo={transactionsInfoItem}
                  />
                );
              })}
            </>
          ) : (
            <EmptyContractsList />
          )}
          <div
            className={transactionsInfo.length ? "paginatorContainer" : "hide"}>
            <Pagination
              count={pagesCount}
              page={page}
              variant="outlined"
              shape="rounded"
              size="medium"
              onChange={handlePaginationChange}
              color="primary"
              siblingCount={1}
              boundaryCount={1}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    "&.MuiButtonBase-root.Mui-selected": {
                      background: "#078DE7",
                      color: "#FFFFFF",
                      borderColor: "transparent",
                      height: { xs: "2em", md: "3em" },
                      width: { xs: "2em", md: "3em" },
                    },
                    "&.MuiPaginationItem-root.MuiPaginationItem-previousNext": {
                      background: "#283743",
                      color: "#FFFFFF",
                      borderColor: "#283743",
                      fontSize: 16,
                    },
                    "&.MuiPaginationItem-root": {
                      color: "#078DE7",
                      borderColor: "#078DE7",
                      fontSize: 18,
                      fontWeight: 800,
                      height: { xs: "2em", md: "3em" },
                      width: { xs: "2em", md: "3em" },
                      borderRadius: "8px",
                    },
                  }}
                />
              )}
            />
          </div>
        </>
      )}
    </Container>
  );
};
export default Wallets;
